export default __webpack_public_path__ + "media/images/icons_fc/info-cd904ba52dd46e9205be716e5359f2cf.png";